module.exports = __webpack_public_path__ + "static/media/video.416e20af.svg";